import { useEffect, useState } from 'react'
import { MembershipProgramHatoHeart } from 'types/membershipProgram'
import { ImageTypeEnum } from 'graphQL/hatostore/generate/operations'
import { isDevelopment } from 'variables/environment'
import * as Sentry from '@sentry/browser'

interface MembershipProgramProps {
  memberShipprogram: MembershipProgramHatoHeart
  membershipTier?: string
}

const useMembershipProgram = ({ memberShipprogram, membershipTier }: MembershipProgramProps) => {
  const [brandLogo, setBrandLogo] = useState('')
  const [coverImage, setCoverImage] = useState('')
  const [tierImage, setTierImage] = useState('')

  useEffect(() => {
    try {
      if (memberShipprogram) {
        const logoImage = getLogoImage()
        const coverImage = getCoverImage()
        const tierImage = getTierImage()
        const coverImageResize = coverImage?.resizableURL.replace('{width}x{height}', '748x1_fmt-png_fit-outside') ?? ''
        setBrandLogo(logoImage)
        setCoverImage(coverImageResize)
        if (tierImage) {
          setTierImage(tierImage)
        }
      }
    } catch (error) {
      !isDevelopment && Sentry.captureException(new Error(`Error from membership program Hato Heart image: ${error}`))
    }
  }, [memberShipprogram, membershipTier])

  const getLogoImage = () => {
    const resizableURL = memberShipprogram?.logoImage?.resizableURL // Use optional chaining
    return resizableURL ? resizableURL.replace('{width}x{height}', '1x200_fmt-png_fit-outside') : '' // Handle empty string if resizableURL is undefined
  }

  const getCoverImage = () => {
    const { images } = memberShipprogram
    return images.find(({ type }) => type === ImageTypeEnum.Cover)
  }

  const getTierImage = () => {
    const { tiers, images } = memberShipprogram
    const currentTier = tiers.find(({ refName }) => refName === membershipTier)
    if (currentTier && currentTier.cardImage) {
      const {
        cardImage: { resizableURL },
      } = currentTier
      return resizableURL.replace('{width}x{height}', '668x1_fmt-png_fit-outside')
    } else {
      const horizontalImage = images.find(({ type }) => type === ImageTypeEnum.Horizontal)
      if (horizontalImage) {
        const { resizableURL } = horizontalImage
        return resizableURL.replace('{width}x{height}', '668x1_fmt-png_fit-outside')
      }
    }
  }

  return { brandLogo, coverImage, tierImage }
}

export default useMembershipProgram
